import { usePageRefresh } from '../../../../context/PageRefreshContext';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getTrialBalanceReport } from '../../../../redux/actions/SocietyPortal/AccountReportsAction/AccountReportsAction';
import { selectedSocietyStorer } from '../../../../utils/webStorer';
import ReportShell, { ReportActionButtons } from '../components/ReportShell';
import { FinancialYearField, DateField, GetReportButton } from '../components/ReportFilters';
import { getCurrentFY, fyDateRange } from '../components/helpers';
import { exportTrialBalance } from '../components/reportExcel';
import TrialBalanceTable from './TrialBalanceTable';

const TrialBalance = () => {
    const dispatch = useDispatch();
    const societyId = selectedSocietyStorer.getSocietyId();
    const { tbData, tbLoading } = useSelector(state => state.AccountReportsReducer || {});

    const [financialYear, setFinancialYear] = useState(getCurrentFY());
    const [asAtDate, setAsAtDate] = useState(fyDateRange(getCurrentFY()).to);
    const [collapseSignal, setCollapseSignal] = useState(0);

    useEffect(() => {
        setAsAtDate(fyDateRange(financialYear).to);
    }, [financialYear]);

    const handleGet = () => {
        if (!societyId) return;
        dispatch(getTrialBalanceReport({ societyId, toDate: asAtDate }));
    };
    usePageRefresh(handleGet);

    useEffect(() => { handleGet(); /* eslint-disable-next-line */ }, [societyId]);

    return (
        <ReportShell
            title="Trial Balance"
            actions={<ReportActionButtons
                onCollapseAll={() => setCollapseSignal((s) => s + 1)}
                onExcel={tbData ? () => exportTrialBalance(tbData) : undefined}
                onPrint={() => window.print()}
            />}
            filters={(
                <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 lg:tw-grid-cols-4 tw-gap-3 tw-items-end">
                    <FinancialYearField value={financialYear} onChange={setFinancialYear} />
                    <DateField label="As at Date" value={asAtDate} onChange={setAsAtDate} />
                    <div></div>
                    <GetReportButton onClick={handleGet} loading={tbLoading} />
                </div>
            )}
        >
            {tbLoading && !tbData ? (
                <div className="tw-flex tw-items-center tw-justify-center tw-py-16">
                    <div className="tw-flex tw-flex-col tw-items-center tw-gap-2">
                        <div className="tw-animate-spin tw-rounded-full tw-h-6 tw-w-6 tw-border-2 tw-border-gray-200 tw-border-t-rose-500"></div>
                        <span className="tw-text-xs tw-text-gray-400">Loading trial balance...</span>
                    </div>
                </div>
            ) : (
                <TrialBalanceTable
                    groups={tbData?.accounts || []}
                    totals={tbData?.totals}
                    collapseAllSignal={collapseSignal}
                />
            )}
        </ReportShell>
    );
};

export default TrialBalance;
